import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var MoveCenter = /*#__PURE__*/function () {
  function MoveCenter() {
    _classCallCheck(this, MoveCenter);

    this.x = 50;
    this.y = 50;
    this.mode = "percent";
    this.radius = 0;
  }

  _createClass(MoveCenter, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.x !== undefined) {
        this.x = data.x;
      }

      if (data.y !== undefined) {
        this.y = data.y;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
    }
  }]);

  return MoveCenter;
}();